import { parseDecimal } from '../../utils';

const COATING_RULES: { pattern: RegExp; value: string }[] = [
    { pattern: /Bl\.Zero/i, value: 'Blue Zero Glacier Plus' },
    { pattern: /GBS/i, value: 'Glacier Blue-Shield UV' },
    { pattern: /GLX/i, value: 'Glacier Expression' },
    { pattern: /\bGP\b/i, value: 'Glacier Plus' },
    { pattern: /HMC/i, value: 'HMC' },
    { pattern: /\bHC\b/i, value: 'HC' },
    { pattern: /\bUC\b/i, value: 'UC' },
    { pattern: /\bGL\b/i, value: 'Glacier' },
    { pattern: /\bGl\b/i, value: 'Glacier' },
];

export const getShamirSTIsPhotochromic = (name: string) =>
    /Foto/i.test(name) || /\bTR\b/i.test(name);

export const getShamirSTPhotochromicColor = (name: string) => {
    if (/\bBR\b/i.test(name)) {
        return 'brązowy';
    }

    if (/\bGR\b/i.test(name)) {
        return 'szary';
    }

    return 0;
};

export const getShamirSTConstruction = (name: string) =>
    /asf/i.test(name) ? 'Asferyczne' : 'Sferyczne';

export const getShamirSTIsColored = (name: string) => /85%/.test(name);

export const getShamirSTCoating = (name: string) => {
    const matchingRule = COATING_RULES.find(({ pattern }) => pattern.test(name));

    return matchingRule?.value ?? 0;
};

const INDEX_RULES: { pattern: RegExp; index: string; frameType: string }[] = [
    { pattern: /^1\.74\b/, index: '1,74', frameType: 'pełna, żyłka' },
    { pattern: /^1\.67\b/, index: '1,67', frameType: 'pełna, żyłka, patent' },
    { pattern: /^1\.59\b/, index: '1,59', frameType: 'pełna, żyłka, patent' },
    { pattern: /^1\.56\b/, index: '1,56', frameType: 'pełna, żyłka' },
    { pattern: /^1\.6\b/, index: '1,6', frameType: 'pełna, żyłka, patent' },
    { pattern: /^1\.5\b/, index: '1,5', frameType: 'pełna, żyłka' },
];

export const getShamirSTIndex = (name: string) => {
    const matchingRule = INDEX_RULES.find(({ pattern }) => pattern.test(name));

    return matchingRule?.index ?? 0;
};

export const getShamirSTFrameType = (name: string) => {
    const matchingRule = INDEX_RULES.find(({ pattern }) => pattern.test(name));

    return matchingRule?.frameType ?? 0;
};

export const formatShamirSTDecimal = (value: string) => {
    const trimmed = value.trim();
    const sign = trimmed.startsWith('+') ? '+' : trimmed.startsWith('-') ? '-' : '';
    const numericPart = trimmed.replace(/^[+-]/, '').replace('.', ',');

    return sign ? `${sign}${numericPart}` : numericPart;
};

export const sumShamirSTDecimals = (...values: string[]) => {
    const sum = values.reduce((acc, value) => acc + parseDecimal(value), 0);
    const formatted = Math.abs(sum).toFixed(2).replace('.', ',');

    if (sum > 0) {
        return `+${formatted}`;
    }

    if (sum < 0) {
        return `-${formatted}`;
    }

    return formatted;
};
